<script setup lang="ts">
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import { Option } from "@/components/forms/inputs/Autocomplete/types";
    import { fetchStudieKvalitetsregister } from "@/components/forms/reusables/studieKvalitetsregisterHelper";

    withDefaults(defineProps<{ shouldBeVisible?: boolean }>(), {
        shouldBeVisible: undefined,
    });

    const converter = ({ value }: { value: { id?: string | Option | unknown; [key: string]: unknown }[] }) => {
        return defaultRepeaterConverter({ value, alwaysArray: true });
    };
</script>

<template>
    <KRepeater
        name="studie_kvalitetsregister"
        add-label="Lägg till studie/kvalitetsregister"
        remove-label="Ta bort studie/kvalitetsregister"
        :converter="converter"
        :shouldBeVisible="shouldBeVisible"
        #default="{ index, model, validation }"
    >
        <KAutocomplete
            name="id"
            label="Studie/Kvalitetsregister"
            :options="fetchStudieKvalitetsregister"
            :value="model?.[index]?.id ?? null"
            :validation="validation"
            class="span-all"
        />
    </KRepeater>
</template>
